import * as R from 'ramda'

export default {
  get (key, defaultValue = null) {
    let val = null
    try {
      val = JSON.parse(sessionStorage.getItem(`PROMETHEUS_${key}`))
    } catch (e) { console.warn('Get from local storage error: ', e) }
    return R.ifElse(R.isNil, R.always(defaultValue), R.always(val))(val)
  },
  getNested (key, nestedKey, defaultValue = null) {
    let val = null
    try {
      val = JSON.parse(sessionStorage.getItem(`PROMETHEUS_${key}`))
    } catch (e) { console.warn('Get from local storage error: ', e) }
    return R.ifElse(
      R.isNil,
      R.always(defaultValue),
      R.propOr(defaultValue, nestedKey),
    )(val)
  },
  save (key, value) {
    return sessionStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(value))
  },
  saveNested (key, nestedKey, value) {
    const val = JSON.parse(sessionStorage.getItem(`PROMETHEUS_${key}`)) || {}
    val[nestedKey] = value
    return sessionStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(val))
  },
  remove (key) {
    return sessionStorage.removeItem(`PROMETHEUS_${key}`)
  },
  removeNested (key, nestedKey) {
    const val = JSON.parse(sessionStorage.getItem(`PROMETHEUS_${key}`))
    delete val[nestedKey]
    return sessionStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(val))
  },
}
